import gql from 'graphql-tag';

import { getSingleProp } from 'src/lib/graphql';
import { executeGqlMutation } from 'src/graphql/client';
import { WORKSPACE_FRAGMENT } from './schema';
import { FRAGMENT_BRAND_VOICE } from '../brandVoices/schema';
import { FRAGMENT_CUSTOMER_RESOURCE, FRAGMENT_INTEGRATION_ACCOUNT } from '../performance/schema';
import { FRAGMENT_FREESTYLE_TOOL } from '../freestyleTools/schema';
import { FRAGMENT_MULTI_PROMPT_TEMPLATE } from '../customerMultiPromptTemplates/schema';
import { FRAGMENT_TALKING_POINTS_VIEW } from '../talkingPointsViews/schema';

const MUTATION = gql`
  mutation UpdateWorkspace(
    $id: ID!
    $name: String!
    $memberEmails: [String!]
    $allowAll: Boolean
    $brandVoiceIds: [ID!]!
    $promptIds: [ID!]!
    $templateIds: [ID!]!
    $integrations: [WorkspaceIntegrationInput!]!
    $resourceIds: [ID!]!
    $talkingPointsViewIds: [ID!]!
    $defaultBrandVoiceId: ID!
  ) {
    updateWorkspace(
      id: $id
      name: $name
      memberEmails: $memberEmails
      allowAll: $allowAll
      brandVoiceIds: $brandVoiceIds
      promptIds: $promptIds
      templateIds: $templateIds
      integrations: $integrations
      resourceIds: $resourceIds
      talkingPointsViewIds: $talkingPointsViewIds
      defaultBrandVoiceId: $defaultBrandVoiceId
    ) {
      ...Workspace
      associatedBrandVoices {
        ...BrandVoice
      }
      associatedAccounts {
        ...PerformanceCenterIntegrationAccount
      }
      associatedFreestyleTools {
        ...SuggestionFreestyleTool
      }
      associatedMultiPromptTemplates {
        ...CustomerMultiPromptTemplate
      }
      associatedResources {
        ...PerformanceCenterCustomerResource
      }
      associatedTalkingPointsViews {
        ...TalkingPointsView
      }
      defaultBrandVoice {
        ...BrandVoice
      }
    }
  }
  ${WORKSPACE_FRAGMENT}
  ${FRAGMENT_BRAND_VOICE}
  ${FRAGMENT_INTEGRATION_ACCOUNT}
  ${FRAGMENT_FREESTYLE_TOOL}
  ${FRAGMENT_MULTI_PROMPT_TEMPLATE}
  ${FRAGMENT_CUSTOMER_RESOURCE}
  ${FRAGMENT_TALKING_POINTS_VIEW}
`;

export const updateWorkspace = ({
  id,
  name,
  memberEmails,
  allowAll,
  brandVoiceIds,
  integrations,
  promptIds,
  templateIds,
  resourceIds,
  talkingPointsViewIds,
  defaultBrandVoiceId,
}) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: {
      id,
      name,
      memberEmails,
      allowAll,
      brandVoiceIds,
      integrations,
      promptIds,
      templateIds,
      resourceIds,
      talkingPointsViewIds,
      defaultBrandVoiceId,
    },
  }).then(({ data }) => getSingleProp(data));
};
